import createReducer from '../../reducers/utils/createReducer';
import * as c from './types';

const initialState = {
  data: {},
  loadingCount: 0,
  isMachinesListLoading: false,
  isMachinesListForProductionLoading: false,
  error: null,
  machines: [],
  machinesStatus: {},
  machineClassifications: {},
  classificationLoading: false,
  highlightedStop: null,
  machinesGroupsLoading: false,
  machinesGroups: [],
  machinesGroupsError: null,
  createMachinesGroupLoading: false,
  createMachinesGroupError: null,
  deleteMachinesGroupLoading: false,
  deleteMachinesGroupError: null,
  updateMachinesGroupLoading: false,
  updateMachinesGroupError: null,
  machinesGroupByUser: {},
  machinesGroupByUserLoading: false,
  machinesGroupByUserError: null,
  addMachinesGroupToUserLoading: false,
  addMachinesGroupToUserError: null
};

export default createReducer(initialState, {
  [c.GET_MACHINES_REQUEST]: (state, { payload }) => {
    return {
      ...state,
      error: null,
      loadingCount: state.loadingCount + 1,
      isMachinesListLoading: payload.isProductionPage ? false : true,
      isMachinesListForProductionLoading: true
    };
  },
  [c.GET_MACHINES_SUCCESS]: (state, { payload }) => {
    const data = { ...state.data };
    const { machines } = payload;

    return {
      ...state,
      data,
      machines,
      loadingCount: state.loadingCount - 1,
      isMachinesListLoading: false,
      isMachinesListForProductionLoading: false
    };
  },
  [c.GET_MACHINES_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
    isMachinesListLoading: false,
    isMachinesListForProductionLoading: false,
    loadingCount: state.loadingCount - 1
  }),
  [c.GET_MACHINE_CLASSIFICATION_REQUEST]: (state) => ({
    ...state,
    error: null,
    classificationLoading: true
  }),
  [c.GET_MACHINE_CLASSIFICATION_SUCCESS]: (state, { payload }) => {
    const machineClassifications = { ...state.machineClassifications };
    const { machineId, data: classification } = payload;
    machineClassifications[machineId] = classification;
    return {
      ...state,
      machineClassifications,
      classificationLoading: false
    };
  },
  [c.GET_MACHINE_CLASSIFICATION_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    classificationLoading: false
  }),
  [c.HIGHLIGHT_STOP]: (state, { payload }) => {
    return {
      ...state,
      highlightedStop: payload
    };
  },
  [c.GET_MACHINES_GROUP_REQUEST]: (state) => ({
    ...state,
    machinesGroupsError: null,
    machinesGroupsLoading: true
  }),
  [c.GET_MACHINES_GROUP_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      machinesGroupsLoading: false,
      machinesGroups: payload
    };
  },
  [c.GET_MACHINES_GROUP_ERROR]: (state, { payload }) => ({
    ...state,
    machinesGroupsError: payload,
    machinesGroupsLoading: false
  }),
  [c.CREATE_MACHINES_GROUP_REQUEST]: (state) => ({
    ...state,
    createMachinesGroupError: null,
    createMachinesGroupLoading: true
  }),
  [c.CREATE_MACHINES_GROUP_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      createMachinesGroupLoading: false,
      machinesGroups: [...[payload.data], ...state.machinesGroups]
    };
  },
  [c.CREATE_MACHINES_GROUP_ERROR]: (state, { payload }) => ({
    ...state,
    createMachinesGroupError: payload,
    createMachinesGroupLoading: false
  }),
  [c.DELETE_MACHINES_GROUP_REQUEST]: (state) => ({
    ...state,
    deleteMachinesGroupError: null,
    deleteMachinesGroupLoading: true
  }),
  [c.DELETE_MACHINES_GROUP_SUCCESS]: (state, { payload }) => {
    const data = state.machinesGroups.filter(
      (group) => group.id !== payload.id
    );
    return {
      ...state,
      deleteMachinesGroupLoading: false,
      machinesGroups: data
    };
  },
  [c.DELETE_MACHINES_GROUP_ERROR]: (state, { payload }) => ({
    ...state,
    deleteMachinesGroupError: payload,
    deleteMachinesGroupLoading: false
  }),
  [c.UPDATE_MACHINES_GROUP_REQUEST]: (state) => ({
    ...state,
    updateMachinesGroupError: null,
    updateMachinesGroupLoading: true
  }),
  [c.UPDATE_MACHINES_GROUP_SUCCESS]: (state, { payload }) => {
    const machinesGroups = [...state.machinesGroups];
    const index = machinesGroups.findIndex(
      (group) => group.id === payload.data.id
    );
    machinesGroups[index] = payload.data;
    return {
      ...state,
      updateMachinesGroupLoading: false,
      machinesGroups
    };
  },
  [c.UPDATE_MACHINES_GROUP_ERROR]: (state, { payload }) => ({
    ...state,
    updateMachinesGroupError: payload,
    updateMachinesGroupLoading: false
  }),
  [c.GET_ASSIGNED_MACHINES_GROUP_FOR_USER_REQUEST]: (state) => ({
    ...state,
    machinesGroupByUserLoading: true,
    machinesGroupByUserError: null
  }),
  [c.GET_ASSIGNED_MACHINES_GROUP_FOR_USER_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      machinesGroupByUser: {
        ...state.machinesGroupByUser,
        [payload.userId]: payload.data
      },
      machinesGroupByUserLoading: false
    };
  },
  [c.GET_ASSIGNED_MACHINES_GROUP_FOR_USER_ERROR]: (state, { payload }) => ({
    ...state,
    machinesGroupByUserLoading: false,
    machinesGroupByUserError: payload
  }),
  [c.ADD_MACHINES_GROUP_TO_USER_REQUEST]: (state) => ({
    ...state,
    addMachinesGroupToUserLoading: true,
    addMachinesGroupToUserError: null
  }),
  [c.ADD_MACHINES_GROUP_TO_USER_SUCCESS]: (state) => {
    return {
      ...state,
      addMachinesGroupToUserLoading: false
    };
  },
  [c.ADD_MACHINES_GROUP_TO_USER_ERROR]: (state, { payload }) => ({
    ...state,
    addMachinesGroupToUserLoading: false,
    addMachinesGroupToUserError: payload
  }),
  [c.GET_MACHINE_REAL_TIME_REQUEST]: (state) => ({
    ...state,
    error: null,
    loadingCount: state.loadingCount + 1
  }),
  [c.GET_MACHINE_REAL_TIME_SUCCESS]: (state, { payload }) => {
    const data = { ...state.data };
    const { machines } = payload;

    return {
      ...state,
      data,
      machines,
      loadingCount: state.loadingCount - 1
    };
  },
  [c.GET_MACHINE_REAL_TIME_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
    loadingCount: state.loadingCount - 1
  }),
  [c.GET_MACHINE_STATUS_SUCCESS]: (state, { payload }) => {
    const newMachines = {};
    payload.map((x) => (newMachines[x.machineId] = x));
    return {
      ...state,
      machinesStatus: {
        ...state.machinesStatus,
        ...newMachines
      }
    };
  }
});
